import './style/style.css';

import { defaultEmoji, defaultRegStr } from './utils/config';
import { transCode2Img, hasEmoji, transCode2ImgFn } from './utils/function';

import { initInput as initInput_pc, initList as initList_pc, handleImgClick as handleImgClick_pc } from './pc';
import { initInput as initInput_mobile, initList as initList_mobile, handleImgClick as handleImgClick_mobile } from './mobile';

/**
 * 
 options:
字段名                  是否必填        类型            默认值                  备注
module                 false          String         'pc'                   'pc'|'mobile'模式
input.inputElement     true           String|DOM     null                   输入框的id
input.defaultContent   false          String         ''                     输入框初始指
input.placeholder      false          String         ''                     输入框placeholder
list.iconElement       true           String|DOM     null                   切换显示隐藏的icon的id
list.wrapElement       mode="mobile"  String|DOM     null                   移动端的时候需要一个表情列表的父元素
list.defaultShow       false          Boolean        false                  初始化时是否直接显示表情列表
list.autoClose         false          Boolean        false                  选择表情后是否自动关闭表情列表
list.width             false          Number         325                    表情列表的宽度，默认325px
list.height            false          Number         170                    表情列表的宽度，默认170px
list.alignment         false          Array<string>  ['left', 'top']        表情下拉框的对齐方式，默认是左、上对齐。可选配置:['left'|'right', 'top'|'bottom']
list.emojis            false          Array<object>  config.defaultEmoji    自定义表情库.[{}]: code:表情的code字符串;src: 表情的图片路径
list.regStr            false          String         config.defaultRegStr   自定义表情库需要的正则

RHEmoji.functions
事件名称                返回值                                   备注
transCode2Img          在输入框中显示的带<img/>的内容             自定义的code转image标签的规则
toggleChange           null                                   切换显示与隐藏时会执行的钩子事件
selectedChange         null                                   选中表情时会执行的钩子事件
getHtml                String                                 返回输入框的innerHTML
getContent             String                                 返回<img/>转成表情code后的字符串,可以直接存库的字符串


others:
1.移动端使用了flex布局。。。。
 */

class RHEmoji {
    constructor(options) {
        // 校验传入的options
        const ckRes = this.checkOptions(options);
        if (!ckRes) return;

        this.icon_el = null;
        this.input_el = null;
        this.lastEditRange = null;
        this.count = 0;

        this.emojis = null;
        this.regStr = null;
        this.options = options;
        this.list_class = 'rhemoji-list';
        this.canToggle = true;

        this.customerEmoji();

        // 处理pc 和 mobile的事件
        if (options.mode && options.mode === 'mobile') {
            this.list_el = null;
            this.deleteIcon = null;
            this.initInput = initInput_mobile.bind(this);
            this.initList = initList_mobile.bind(this);
            this.handleImgClick = handleImgClick_mobile.bind(this);
        } else {
            this.initInput = initInput_pc.bind(this);
            this.initList = initList_pc.bind(this);
            this.handleImgClick = handleImgClick_pc.bind(this);
        }

        this.init();
    }

    checkOptions(options) {
        if (!options || !options.input || !options.list || !options.input.inputElement || !options.list.iconElement) {
            console.error('input.inputElement and list.iconElement is required!');
            return false;
        }

        if (options.mode && options.mode === 'mobile' && !options.list.wrapElement) {
            console.error('wrapElement is required in mobile mode!');
            return false;
        }

        return true;
    }

    customerEmoji() {
        const {
            list: { emojis, regStr },
        } = this.options;

        if (emojis && regStr) {
            this.emojis = emojis;
            this.regStr = regStr;
        } else {
            this.emojis = defaultEmoji;
            this.regStr = defaultRegStr;
        }
    }

    init() {
        const { input, list } = this.options;

        this.initInput(input);
        this.initList(list);
    }
}

RHEmoji.prototype.getHtml = function() {
    return this.input_el.innerHTML;
};

RHEmoji.prototype.getContent = function() {
    const imgReg = /<img.*?(?:">|\/">)/gi; //匹配图片中的img标签
    const content = this.input_el.innerHTML.replace(imgReg, i => {
        if (i.match(/data-type="(\S*)"/)[1]) {
            const imgStr = i.match(/data-type="(\S*)"/)[1];
            const formarStr = imgStr.replace(/&amp;/g, '&');
            if (hasEmoji(this.emojis, formarStr)) {
                return formarStr;
            } else {
                return '';
            }
        }
    });
    return content;
};

// 改变输入框值的时候触发的事件，修改count等
RHEmoji.prototype.onContentChange = function(data) {
    if (data === '<br>') {
        this.count = 0;
        this.onChange && this.onChange();
        return;
    }

    let content = data
        .replace(/&nbsp;/g, ' ')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&amp;/g, '&')
        .replace(/&quot;/g, '"')
        .replace(/&apos;/g, "'");
    const { regStr, emojis } = this;
    const reg = new RegExp(regStr, 'g');
    content = content.replace(reg, function(r) {
        const emojiObj = hasEmoji(emojis, r);
        if (emojiObj) {
            return 'E';
        } else {
            return r;
        }
    });
    this.count = content.length;
    this.onChange && this.onChange();
};

RHEmoji.prototype.clear = function() {
    this.onContentChange('');
    this.input_el.innerHTML = '';
};

RHEmoji.prototype.closeEmojiList = function() {
    this.list_el.style.display = 'none';
};

RHEmoji.prototype.transCode2Img = transCode2Img;

RHEmoji.prototype.toggleChange = null;

RHEmoji.prototype.selectedChange = null;

RHEmoji.prototype.onChange = null;

// module.exports = RHEmoji;

export default RHEmoji;

export { transCode2ImgFn };
